import { AddProps, convertProps, IFormItemProps, MyModal } from "@/Common/Form/MyModal";
import { Department } from "@/Models/Tables/Department";
import { Form, Input } from "antd";
import { useCallback } from "react";

function Item(props: IFormItemProps<Department>) {
    return <Form.Item {...convertProps(props)}  ></Form.Item>;
}

function Add({ onCancel, onSubmit, data }: AddProps<Department>) {
    const [form] = Form.useForm();
    const onOk = useCallback(() => {
        form.validateFields().then(onSubmit);
    }, [form, onSubmit]);
    return <MyModal name="部门" data={data} width={360} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" initialValues={data} labelCol={{ span: 8 }}>
            <Item name="name" label="部门名称" required >
                <Input ></Input>
            </Item>
            <Item name="code" label="部门编码" required >
                <Input ></Input>
            </Item>
            <Item name="remark" label="备注" >
                <Input.TextArea rows={3} ></Input.TextArea>
            </Item>
        </Form>
    </MyModal>;
}

export default Add;